type ConflictInput<T extends WithUpdatedAt> = {
  assumedMasterState?: T;
  newDocumentState: T;
  realMasterState: T;
};

type WithUpdatedAt = { updatedAt: string };

const isEqual = <T extends WithUpdatedAt>(
  a: T,
  b: T,
  _context: string,
): boolean => {
  void _context;

  const keys = new Set([...Object.keys(a), ...Object.keys(b)]) as Set<keyof T>;
  for (const key of keys) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
};

const resolve = async <T extends WithUpdatedAt>(
  input: ConflictInput<T>,
  _context: string,
): Promise<T> => {
  void _context;

  return input.newDocumentState.updatedAt > input.realMasterState.updatedAt
    ? input.newDocumentState
    : input.realMasterState;
};

export const lwwConflictHandler = { isEqual, resolve };
